import {
	GET_REGIONS,
	GET_REGIONS_SUCCESS,
	GET_REGIONS_FAIL,
	GET_REGIONS_RESET,
} from '../actions/getRegionsAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getRegionsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_REGIONS:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_REGIONS_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_REGIONS_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_REGIONS_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getRegionsReducer;
